import LocationListPage from './list'
import LocationAddPage from './add'
import LocationViewPage from './view'

export default {
  LocationListPage,
  LocationViewPage,
  LocationAddPage
}
